import * as Highcharts from 'highcharts';
import * as Highstock from 'highcharts/highstock';

const modifiedOptions = {
  chart: {
    styledMode: true,
    style: {
      fontFamily: 'Frutiger, Arial, sans-serif;',
      fontSize: '20px',
    },
  },
  lang: {
    decimalPoint: ',',
    thousandsSep: '.',
    loading: 'Daten werden geladen...',
    months: [
      'Januar',
      'Februar',
      'März',
      'April',
      'Mai',
      'Juni',
      'Juli',
      'August',
      'September',
      'Oktober',
      'November',
      'Dezember',
    ],
    weekdays: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
    shortMonths: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
  },
};

// Method ts-doc may be wrong.
// Funtion returns something and copys passed argument into highcharts defaultOptions.
// See https://github.com/highcharts/highcharts/blob/master/ts/Core/Defaults.ts#L2879
Highcharts.setOptions(modifiedOptions);
Highstock.setOptions(modifiedOptions);
